<template>
  <div class="list-box bg-gray-100 rounded-lg jiesong" id="jiesong">
    <div
      class="flex-1 flex flex-col relative bg-white rounded-lg px-5 overflow-hidden"
    >
      <el-tabs
        v-model="state.type"
        class="c-el-tabs-auto-height mt-2 mb-2 flex-1"
      >
        <el-tab-pane label="接送机安排" name="paiche">
          <c_paiche
            v-if="state.type == 'paiche'"
            :meeting_id="props.meeting_id"
          />
        </el-tab-pane>
        <el-tab-pane label="司机排班" name="paiban">
          <c_paiban
            v-if="state.type == 'paiban'"
            :meeting_id="props.meeting_id"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

import c_paiche from "./PaiChe/List.vue";
import c_paiban from "./PaiBan/List.vue";

export default {
  components: {
    c_paiche,
    c_paiban,
  },
  props: {
    meeting_id: Number,
  },
  setup(props) {
    const state = reactive({
      type: "paiche",
      params: {},
    });
    onMounted(() => {});

    return {
      state,
      props,
    };
  },
};
</script>

<style lang="scss" scoped></style>
